/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Script } from "gatsby"
import gsap from "gsap"
import { TransitionPortal } from "gatsby-plugin-transition-link"

import Header from "./header"
import Footer from "./footer"
// import SocialIcons from './social-icons';

import variables from "../utils/variables"

import "./layout.css"

const styles = {
  pageWrapper: {
    width: "100%",
    overflow: "hidden",
    minHeight: "100vh",
    backgroundColor: variables.colors.white,
  },
}

const Layout = ({
  headerDark,
  socialDark,
  currentPage,
  children,
  updateBreakpoint,
}) => {
  let transitionCoverLayer1 = React.createRef()
  let transitionCoverLayer2 = React.createRef()

  const transitionExit = ({ length }, direction) => {
    return gsap
      .timeline()
      .set(transitionCoverLayer1, { x: "-100%" })
      .set(transitionCoverLayer2, { x: "-100%" })
      .to(transitionCoverLayer1, {
        x: "0",
        ease: "power1.easeInOut",
        duration: length,
      })
      .to(transitionCoverLayer2, {
        x: "0",
        ease: "power1.easeInOut",
        duration: (length / 3) * 2,
        delay: -((length / 3) * 2),
      })
  }
  if (typeof window !== `undefined`) {
    window.transitionExit = transitionExit
  }

  const transitionEnter = ({ length }, node) => {
    return gsap
      .timeline()
      .set(transitionCoverLayer1, { x: "0" })
      .set(transitionCoverLayer2, { x: "0" })
      .to(transitionCoverLayer1, {
        x: "100%",
        ease: "power1.easeInOut",
        duration: length,
      })
      .to(transitionCoverLayer2, {
        x: "100%",
        ease: "power1.easeInOut",
        duration: (length / 3) * 2,
        delay: -((length / 3) * 2),
      })
  }
  if (typeof window !== `undefined`) {
    window.transitionEnter = transitionEnter
  }
  let processing = false
  const [currentBreakPoint, setCurrentBreakPoint] = useState({
    type: null,
    bp: null,
  })
  const [openedBurgerMenu, setOpenedBurgerMenu] = useState(false)

  const [loaded, setloaded] = useState(false)

  const toggleBurgerMenu = () => {
    setOpenedBurgerMenu(!openedBurgerMenu)
  }
  const updateSize = () => {
    const w = typeof window !== "undefined" ? window.innerWidth : 0
    let breakpoint = null
    let type = null

    if (w >= variables.breakpoints["xxxl"]) {
      breakpoint = "xxxl"
      type = "desktop"
    } else if (w >= variables.breakpoints["xxl"]) {
      breakpoint = "xxl"
      type = "desktop"
    } else if (w >= variables.breakpoints["xl"]) {
      breakpoint = "xl"
      type = "desktop"
    } else if (w >= variables.breakpoints["l"]) {
      breakpoint = "l"
      type = "mobile"
    } else if (w >= variables.breakpoints["m"]) {
      breakpoint = "m"
      type = "mobile"
    } else if (w >= variables.breakpoints["s"]) {
      breakpoint = "s"
      type = "mobile"
    } else {
      breakpoint = "xs"
      type = "mobile"
    }

    if (
      currentBreakPoint.type !== type ||
      currentBreakPoint.bp !== breakpoint
    ) {
      setCurrentBreakPoint({
        bp: breakpoint,
        type,
      })

      if (updateBreakpoint) {
        updateBreakpoint({
          bp: breakpoint,
          type,
        })
      }
      console.log("updateSize", breakpoint, type)
      setOpenedBurgerMenu(false)
      setTimeout(() => {
        console.log("timeout", breakpoint, type)
        processing = false
      }, 200)
    }
  }

  const handleResize = () => {
    if (!loaded) {
      setloaded(true)
    }
    if (processing === false) {
      processing = true

      updateSize()
    }
  }
  React.useEffect(() => {
    if (typeof window !== `undefined`) {
      window.addEventListener("resize", handleResize)
      handleResize()
    }
    return () => {
      if (typeof window !== `undefined`) {
        window.removeEventListener("resize", handleResize)
      }
    }
  }, [])

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          {/* <Script>
            {`(function(d,t) {
                  var BASE_URL="https://ludusone-chatwoot-production.herokuapp.com";
                  var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
                  g.src=BASE_URL+"/packs/js/sdk.js";
                  g.defer = true;
                  g.async = true;
                  s.parentNode.insertBefore(g,s);
                  g.onload=function(){
                    window.chatwootSDK.run({
                      websiteToken: 'LvBjgW4FpRj5i1XgHkdfQAqk',
                      baseUrl: BASE_URL
                    })
                  }
                })(document,"script");`}
          </Script> */}
          {loaded ? (
            <div
              style={{
                ...styles.pageWrapper,
                height: openedBurgerMenu ? "100vh" : "auto",
              }}
            >
              <Header
                dark={headerDark}
                siteTitle={data.site.siteMetadata.title}
                currentPage={currentPage}
                openedMenu={openedBurgerMenu}
                toggleMenu={toggleBurgerMenu}
                currentBreakPoint={currentBreakPoint.type}
              />

              <main style={{ maxWidth: "100%", overflow: "hidden" }}>
                {children}
              </main>

              <Footer />
              {/* {currentBreakPoint.type === 'desktop' ? (
              <SocialIcons
                dark={socialDark}
              />
            ) : null } */}
            </div>
          ) : null}

          {/* <div className="loading">Loading</div> */}
          <TransitionPortal>
            <div
              ref={n => (transitionCoverLayer1 = n)}
              style={{
                position: "fixed",
                background: "#4E56FF",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                transform: "translateX(-100%) translateZ(0px)",
              }}
            />
            <div
              ref={n => (transitionCoverLayer2 = n)}
              style={{
                position: "fixed",
                background: "#333342",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                transform: "translateX(-100%) translateZ(0px)",
              }}
            />
          </TransitionPortal>
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
